<template>
  <div class="ctrl-login">
    <div class="wrap">
      <CtrlArticleAricles :categoryId="categoryId" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CtrlArticleAricles from "@/components/Ctrl/Article/Articles.vue";
export default {
  name: "ctrl-login",
  components: {
    CtrlArticleAricles,
  },
  props: {
    categoryId: String,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["rootUrl"]),
  },
};
</script>

<style lang="scss" scoped>
</style>
